// --- スライダー (Slick) の初期化 ---
$('.slider__active').slick({
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 800,
    dots: false,
    arrows: false,
    infinite: true,
    centerMode: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: false
});

// --- GSAP / ScrollTrigger の初期化 ---
gsap.registerPlugin(ScrollTrigger);

function initParallax() {
    const wrappers = document.querySelectorAll('.parallax-wrapper');
    if (wrappers.length === 0) return;

    wrappers.forEach((wrapper, i) => {
        const image = wrapper.querySelector('.parallax-image');
        const content = wrapper.querySelector('.p-feature__cont__content');
        const textBlocks = wrapper.querySelectorAll('.text-block');

        if (!image || !content) return;

        // レイアウトの更新（無限ループを防ぐため、ここでは ScrollTrigger.refresh() を呼ばない）
        const updateLayoutPosition = () => {
            const imgHeight = image.offsetHeight;
            if (imgHeight > 0) {
                gsap.set(content, { marginTop: -imgHeight });
            }
        };

        // 画像ロード待機
        const imgElement = image.querySelector('img');
        if (imgElement) {
            if (imgElement.complete) {
                updateLayoutPosition();
            } else {
                imgElement.addEventListener('load', () => {
                    updateLayoutPosition();
                    ScrollTrigger.refresh(); // 画像読み込み完了時のみリフレッシュ
                });
            }
        }

        updateLayoutPosition();

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: wrapper,
                start: 'top top',
                end: () => `+=${image.offsetHeight}`,
                scrub: true,
                pin: true,
                pinSpacing: true,
                invalidateOnRefresh: true,
                anticipatePin: 1,
                refreshPriority: wrappers.length - i,
                onRefresh: updateLayoutPosition // リフレッシュ時に位置を再計算（再リフレッシュは呼ばない）
            }
        });

        tl.fromTo(content,
            { y: () => image.offsetHeight },
            { y: 0, ease: 'none', lazy: false }
        );

        textBlocks.forEach((block, index) => {
            gsap.to(block, {
                opacity: 1,
                y: 0,
                duration: 0.8,
                delay: index * 0.1,
                scrollTrigger: {
                    trigger: block,
                    start: 'top 85%',
                    toggleActions: 'play none none none'
                }
            });
        });
    });

    // リサイズ時の安定化
    let resizeTimer;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            ScrollTrigger.refresh();
        }, 250);
    });
}

// 実行の確実性を担保する初期化処理
function initializeAll() {
    initParallax();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
} else {
    initializeAll();
}

window.addEventListener('load', () => {
    ScrollTrigger.refresh();
});

// --- ヘッダー操作 (閉じるボタン・操作中非表示) ---
(function() {
    const headerSelector = '.p-lp-header-fixed';
    const dismissedClass = 'is-hidden';
    const interactionClass = 'is-interaction-hidden';
    let isGlobalInteracting = false;

    // 「×」ボタンのイベント委譲（Delegate）
    document.addEventListener('click', function(e) {
        const cross = e.target.closest('.c-cross');
        if (cross) {
            e.preventDefault();
            const header = document.querySelector(headerSelector);
            const fv = document.querySelector('.p-fv.l-fv');
            if (header) header.classList.add(dismissedClass);
            if (fv) fv.classList.add('no-padding');
        }
    });

    // タッチデバイス用の「×」ボタン対応
    document.addEventListener('touchend', function(e) {
        const cross = e.target.closest('.c-cross');
        if (cross) {
            e.preventDefault();
            const header = document.querySelector(headerSelector);
            const fv = document.querySelector('.p-fv.l-fv');
            if (header) header.classList.add(dismissedClass);
            if (fv) fv.classList.add('no-padding');
        }
    }, { passive: false });

    // 操作中の一時非表示（キャッチフェーズで確実に捕捉）
    function updateInteractionVisibility() {
        const lpHeader = document.querySelector(headerSelector);
        if (!lpHeader || lpHeader.classList.contains(dismissedClass)) return;

        if (isGlobalInteracting) {
            lpHeader.classList.add(interactionClass);
        } else {
            lpHeader.classList.remove(interactionClass);
        }
    }

    window.addEventListener('pointerdown', () => {
        isGlobalInteracting = true;
        updateInteractionVisibility();
    }, { capture: true, passive: true });

    window.addEventListener('pointerup', () => {
        isGlobalInteracting = false;
        updateInteractionVisibility();
    }, { capture: true, passive: true });

    window.addEventListener('pointercancel', () => {
        isGlobalInteracting = false;
        updateInteractionVisibility();
    }, { capture: true, passive: true });

    // スマホでの操作中非表示（touchstart/touchendでも補強）
    window.addEventListener('touchstart', () => {
        isGlobalInteracting = true;
        updateInteractionVisibility();
    }, { capture: true, passive: true });

    window.addEventListener('touchend', () => {
        isGlobalInteracting = false;
        updateInteractionVisibility();
    }, { capture: true, passive: true });
})();

// --- スライダー周りの非表示ボックス ---
let isHover = false;
let isPointerDown = false;

function updateFeatureBox() {
    if (isHover || isPointerDown) {
        $('.p-feature__cont_user_box').stop(true, true).fadeOut(300);
    } else {
        $('.p-feature__cont_user_box').stop(true, true).fadeIn(300);
    }
}

$('.slider')
    .on('mouseenter', function () {
        isHover = true;
        updateFeatureBox();
    })
    .on('mouseleave', function () {
        isHover = false;
        updateFeatureBox();
    })
    .on('mousedown touchstart', function () {
        isPointerDown = true;
        updateFeatureBox();
    })
    .on('mouseup touchend touchcancel', function () {
        isPointerDown = false;
        updateFeatureBox();
    });